import { z } from 'zod';

// ─── Supported language ───────────────────────────────────────────────────────

export type TSupportedLanguage = {
  code: string;
  name: string;
  nativeName: string;
};

export const getSupportedLanguages = (): TSupportedLanguage[] => [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
];

// ─── Menu item translation ────────────────────────────────────────────────────

export const menuTranslationSchema = z.object({
  name: z.string().trim().min(1, 'Name is required'),
  description: z.string().optional(),
  allergies: z.string().optional(),
  nutritions: z.string().optional(),
  dishnote: z.string().optional(),
});

export type TMenuTranslationFields = z.infer<typeof menuTranslationSchema>;

export type TMenuTranslation = {
  _id?: string;
  lang: string;
} & TMenuTranslationFields;

export type TMenuTranslationResponse = {
  success: boolean;
  data?: { rows: TMenuTranslation[] };
  msg?: string;
};

export type TCreateMenuTranslationPayload = {
  restaurantId: string;
  menuItemId: string;
  translationData: { lang: string } & TMenuTranslationFields;
};

export type TTranslationStatus = {
  language: TSupportedLanguage;
  exists: boolean;
  data: TMenuTranslation | null;
};

// ─── Menu attribute translation ───────────────────────────────────────────────

export const menuAttributeTranslationSchema = z.object({
  name: z.string().trim().min(1, 'Name is required'),
  description: z.string().optional(),
});

export type TMenuAttributeTranslationFields = z.infer<typeof menuAttributeTranslationSchema>;

export type TMenuAttributeTranslation = {
  _id?: string;
  lang: string;
} & TMenuAttributeTranslationFields;

export type TMenuAttributeTranslationResponse = {
  success: boolean;
  data?: { rows: TMenuAttributeTranslation[] };
  msg?: string;
};

export type TCreateMenuAttributeTranslationPayload = {
  restaurantId: string;
  attributeId: string;
  translationData: { lang: string } & TMenuAttributeTranslationFields;
};

// ─── Allergen translation ─────────────────────────────────────────────────────

export const allergenTranslationSchema = z.object({
  name: z.string().trim().min(1, 'Name is required'),
  description: z.string().optional(),
});

export type TAllergenTranslationFields = z.infer<typeof allergenTranslationSchema>;

export type TAllergenTranslation = {
  _id?: string;
  lang: string;
} & TAllergenTranslationFields;

export type TAllergenTranslationResponse = {
  success: boolean;
  data?: { rows: TAllergenTranslation[] };
  msg?: string;
};

export type TCreateAllergenTranslationPayload = {
  restaurantId: string;
  allergenId: string;
  translationData: { lang: string } & TAllergenTranslationFields;
};
